module.exports = __webpack_public_path__ + "static/img/event24.e3d4ff7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/event24.png
// module id = ekzq
// module chunks = 1